import script from "./AssetsUser2.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetsUser2.vue?vue&type=script&setup=true&lang=js"

import "./AssetsUser2.vue?vue&type=style&index=0&id=1ffc4c7d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ffc4c7d"]])

export default __exports__